export class ComparisonTable {
	init = () => {
		var tables = document.querySelectorAll('[data-role="spec-table-expand"]');
		tables.forEach(t => {
			t.addEventListener('click', (e) => {
				var target = t.getAttribute('data-target');
				document.querySelector(`[data-role="${target}-spec-table-div"]`).classList.remove('collapsed');
				t.classList.add('d-none');
			});
		});
	}
}
